import { render, staticRenderFns } from "./MemberLevels.vue?vue&type=template&id=3a22554d&scoped=true&"
import script from "./MemberLevels.vue?vue&type=script&lang=js&"
export * from "./MemberLevels.vue?vue&type=script&lang=js&"
import style0 from "./MemberLevels.vue?vue&type=style&index=0&id=3a22554d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22554d",
  null
  
)

export default component.exports